import { FileTypes, getStorageObjectPath } from '@usacsmideo/types';
import { auth } from '../constants/firebaseModular';

export const getFileUploadPath = (type: FileTypes): string => {
  const patientId = auth?.currentUser?.uid ?? '';
  return getStorageObjectPath(patientId, type);
};
